import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { StringHelper } from "../../../core/helpers/strings.helper";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
	DeviceRegistrationOtpModel,
} from "../../../shared/models/device.model";
import { DeviceService } from "../../../core/services/device.service";

@Component({
	selector: 'app-otp',
	templateUrl: './otp.component.html',
	styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {

	@Output() submitCallBack = new EventEmitter();
	@Output() cancelCallBack = new EventEmitter();
	@Output() resentOtpCallBack = new EventEmitter();
	@Input() loadingButton: boolean;
	@Input() otpResponse: DeviceRegistrationOtpModel;
	@Input() errorMessage: string;

	otpForm!: FormGroup
	currentStepIndex: number
	loadingText = 'moniepoint.loading';
	timer: number;
	countDown: boolean;
	countDownTimer: number;
	deadline: number;


	constructor(public deviceService: DeviceService, private fb: FormBuilder) { }

	ngOnInit(): void {
		this.otpForm = this.fb.group({
			otp: [null, [Validators.required, this.otpValidation]],
		});
		this.pageLoad();
	}

	pageLoad() {
		this.currentStepIndex = 2;
		this.triggerOtpDeviceReg();
	}

	triggerOtpDeviceReg() {
		this.timer = this.otpResponse.retryTimer || 60;
		this.setTimerValue();
		this.deadline = Date.now() + 1000 * 60 + 1000 * 1;
		this.currentStepIndex = 0;
		this.loadingButton = false;
	}

	otpValidation(control: AbstractControl): { [key: string]: any } | null {
		let otp = control.value;
		let isValid = StringHelper.validOTP(otp);
		if (isValid) {
			return null;
		}
		else {
			return { 'otp': true };
		}
	}


	resendOtp() {
		this.loadingButton = true;
		this.resentOtpCallBack.emit(true);
	}

	setTimerValue() {
		this.countDown = true;
		// @ts-ignore
		this.countDownTimer = setInterval(() => {
			this.timer--;
			if (this.timer === 0) {
				this.countDown = false;
				clearInterval(this.countDownTimer);
				this.timer = 60;
			}
		}, 1000);
	}


	submitOtp() {
		let form = this.otpForm?.value
		let otp = form?.otp;
		this.submitCallBack.emit(otp);
	}

	cancel() {
		this.cancelCallBack.emit(true);
	}

}
